import React from 'react';

const NotFound = (props) => {

    return (
        <h1>Not Found</h1>
    )
}

export default NotFound;